import React, { useEffect, useState } from 'react';
import { useQuery } from 'urql';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import DealsGrid from './DealsGrid';
import { healthyDealsFilterDealsQuery } from '../../graphql/queries';
import DealsGridPagination from './DealsGridPagination';
import { useHealthyDealsDataContext } from '../HealthyDealsDataContextProvider/HealthyDealsData.context';
import { cardsPerPage } from '../../utils/miscConstants';

export default function ListOfDeals({ category = null }) {
	const [prevCategory, setPrevCategory] = useState(category);
	const {
		selectedCategorySavedInContext,
		setPrevPageTitle,
		setMainTitleTo,
		skipDataForPageFromContext,
		setSkipDataForPageFromContext,
		setPaginationPageFromContext,
	} = useHealthyDealsDataContext();

	const [result] = useQuery({
		query: healthyDealsFilterDealsQuery,
		variables: {
			skip: skipDataForPageFromContext,
			take: cardsPerPage,
			filterOptionIDs: [category?.id || ''],
		},
	});
	const { fetching, error, data } = result;
	if (error) {
		throw error;
	}
	useEffect(() => {
		const pageTitle = selectedCategorySavedInContext?.label
			? `“${selectedCategorySavedInContext?.label}” Results`
			: setMainTitleTo;
		setPrevPageTitle(pageTitle);

		if (category?.id !== prevCategory?.id) {
			setPrevCategory(category);
			setPaginationPageFromContext(1);
			setSkipDataForPageFromContext(0);
		}
	}, [selectedCategorySavedInContext, category, prevCategory]);

	return (
		<Stack mt={2.25}>
			<Box mt={2}>
				{data?.healthyDealsFilterDeals?.totalCount > 0 && !fetching ? (
					category?.id && (
						<Typography variant="h5" component="h3">
							{`${data?.healthyDealsFilterDeals?.totalCount} Results`}
						</Typography>
					)
				) : (
					<Skeleton variant="text" width={100} />
				)}
			</Box>
			<DealsGrid
				deals={data?.healthyDealsFilterDeals?.items || []}
				loading={fetching}
			/>
			<Stack mt={3} alignItems="center">
				<DealsGridPagination
					dealsTotalCount={data?.healthyDealsFilterDeals?.totalCount || 0}
					loading={fetching}
					setSkipData={setSkipDataForPageFromContext}
				/>
			</Stack>
		</Stack>
	);
}

ListOfDeals.propTypes = {
	category: PropTypes.object,
};
